// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__aNwPl","sidebarSlot":"AppShell_sidebarSlot__br2Uo","mainColumn":"AppShell_mainColumn__0z--v","main":"AppShell_main__fpyDT"};